import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import ExitToApp from '@material-ui/icons/ExitToApp';
import ConfirmationNumber from '@material-ui/icons/ConfirmationNumber';
import { red } from '@material-ui/core/colors';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    margin: theme.spacing(2, 0),
  },
  infoButton: {
    display: 'inline-flex',
    alignItems: 'center',
  },
  infoIcon: {
    marginLeft: theme.spacing(0.5),
  },
  registrationRequired: {
    marginTop: theme.spacing(1),
    fontStyle: 'italic',
    color: red[600],
    display: 'flex',
    alignItems: 'center',
  },
  registrationIcon: {
    marginRight: theme.spacing(0.5),
  },
}));

const InfoUrlButton = ({ event }) => {
  const classes = useStyles();

  if (!event.infoUrl) {
    return null;
  }

  const { infoUrl } = event;

  return (
    <div className={classes.wrapper}>
      <Button
        href={infoUrl}
        rel="noopener noreferrer"
        color="primary"
        variant="contained"
        className={classes.infoButton}
      >
        Learn More ({infoUrl.replace(/^https?:\/\//, '').replace(/\/.*$/, '')})
        <ExitToApp className={classes.infoIcon} />
      </Button>
      {event.registrationType === 'EXTERNAL_REGISTRATION' && (
        <div className={classes.registrationRequired}>
          <ConfirmationNumber fontSize="small" className={classes.registrationIcon} />
          External registration is required
        </div>
      )}
    </div>
  );
};

InfoUrlButton.propTypes = {
  event: PropTypes.object.isRequired,
};

export default InfoUrlButton;
